// extracted by mini-css-extract-plugin
module.exports = {"container":"sprintsWalkthrough_container__2V-5B","seperation-line":"sprintsWalkthrough_seperation-line__1zWjJ"};